/**
 * 全局轮询管理
 * 用于轮询获取最新动态通知
 */

import { notification } from 'antd';
import { API_getTodayFirstSubscriptionLog } from '@/services/ant-design-pro/api';

// 轮询间隔（15秒）
const POLL_INTERVAL = 15000;

// 全局轮询定时器
let globalPollInterval: NodeJS.Timeout | null = null;

/**
 * 停止全局轮询
 */
export function stopGlobalPolling(): void {
  if (globalPollInterval) {
    console.log('[轮询管理] 清除轮询');
    clearInterval(globalPollInterval);
    globalPollInterval = null;
  }
}

/**
 * 启动全局轮询
 */
export function startGlobalPolling(): void {
  // 如果已有轮询，不重复启动
  if (globalPollInterval) {
    return;
  }

  console.log('[轮询管理] 启动轮询（15秒间隔）');

  // 轮询执行函数
  const pollHandler = async () => {
    try {
      const response = await API_getTodayFirstSubscriptionLog();

      if (response.data) {
        notification.open({
          message: '最新动态',
          description: response.data.description,
          placement: 'topRight',
          duration: 5,
          type: response.data.type === 'ORDER' ? 'success' : 'info',
        });
      }
    } catch (error) {
      console.error('[轮询管理] 轮询最新动态失败:', error);
    }
  };

  // 立即执行一次
  pollHandler();

  // 设置轮询间隔
  globalPollInterval = setInterval(pollHandler, POLL_INTERVAL);
}

/**
 * 根据路由变化管理轮询状态
 * @param shouldPoll 是否应该轮询
 */
export function handleRouteChangeForPolling(shouldPoll: boolean): void {
  if (shouldPoll) {
    startGlobalPolling();
  } else {
    stopGlobalPolling();
  }
}
